import { WorklistValues } from "features/WorklistTools/shared/interfaces";
import { isStringifiedInteger } from "features/WorklistTools/shared/WorklistHelpers";
import { useAppReduxSelector } from "hooks/reduxHooks";
import React from "react";
import { TextEditor } from "react-data-grid";
import { useDispatch } from "react-redux";
import { Alert, AlertType } from "shared-components/toast";
import { PoolingNormalizationToolActions } from "../../state";
import { WellMapping } from "../WellMapping";
import { WellMappingTableHeader } from "../WellMappingTableHeader";

export const DestinationWellMapping = () => {
  const dispatch = useDispatch();
  const reduxState = useAppReduxSelector(
    (state) => state.WorklistTools.PoolingNormalizationTool.present
  );

  const worklistValues = reduxState.worklistValues;

  const columns = [
    {
      key: "sourcePlateIndex",
      name: "Source Plate",
      formatter(props: any) {
        return <>{props.row.sourcePlateIndex + 1}</>;
      },
      resizable: true,
    },
    { key: "sourceWellId", name: "Source Pos", resizable: true },
    {
      key: "destPlateIndex",
      name: "Dest Plate",
      formatter(props: any) {
        return <>{props.row.destPlateIndex + 1}</>;
      },
      resizable: true,
    },
    { key: "destWellId", name: "Dest Pos", resizable: true },
    {
      key: "transferVol",
      name: "Cell Number",
      resizable: true,
      editor: TextEditor,
      formatter({ row }: any) {
        const value = row.transferVol;
        const parsed = parseInt(value, 10);
        return <>{!isNaN(parsed) ? parsed.toLocaleString("en-US") : value}</>;
      },
    },
  ];

  const handleApplyCellNumber = (
    option: string | number,
    cellNumber: number | undefined
  ) => {
    switch (option) {
      case "Apply to All":
        dispatch(
          PoolingNormalizationToolActions.UPDATE_ALL_DEST_STAMP_CELL_NUMBER({
            transferVol: cellNumber,
          })
        );
        break;
      case "Apply to Empty":
        dispatch(
          PoolingNormalizationToolActions.UPDATE_EMPTY_DEST_CELL_NUMBERS({
            transferVol: cellNumber,
          })
        );
        break;
      default:
        dispatch(
          PoolingNormalizationToolActions.UPDATE_SPECIFIC_DEST_CELL_NUMBERS({
            transferVol: cellNumber,
            destPlateIndex: option,
          })
        );
        break;
    }
  };

  const setSingleCellNumber = (rows: unknown[]) => {
    const typedRows = rows as WorklistValues[];

    for (const row of typedRows) {
      if (
        row.transferVol !== "" &&
        row.transferVol &&
        !isStringifiedInteger(row.transferVol)
      ) {
        return Alert({
          type: AlertType.ERROR,
          message: "Please enter a valid whole number",
        });
      }
    }
    dispatch(
      PoolingNormalizationToolActions.UPDATE_DEST_CELL_NUMBER({
        rows,
      })
    );
  };

  return (
    <React.Fragment>
      <WellMapping
        setSingleCellNumber={setSingleCellNumber}
        columns={columns}
        worklistValues={[
          ...worklistValues.int1ToDest,
          ...worklistValues.int2ToDest,
          ...worklistValues.int3ToDest,
        ]}
        tableHeader={
          <WellMappingTableHeader
            handleApplyCellNumber={handleApplyCellNumber}
            destPlates={reduxState.destPlateInfo}
          />
        }
      />
    </React.Fragment>
  );
};
